var _path, _path2, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEtcIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M13 26C20.1797 26 26 20.18 26 13C26 5.82 20.1797 0 13 0C5.8203 0 0 5.82 0 13C0 20.18 5.8203 26 13 26Z",
    fill: "#3AB83A"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1320_2092",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 26,
    height: 26
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13 26C20.1797 26 26 20.18 26 13C26 5.82 20.1797 0 13 0C5.8203 0 0 5.82 0 13C0 20.18 5.8203 26 13 26Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1320_2092)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 12.326L13.5144 10.042L17 12.34L13.499 6L10 12.326ZM10.1341 12.986L13.5182 10.756L16.8583 12.969L13.5201 15.202L10.1341 12.986ZM10 13.624C11.2334 14.433 12.5204 15.28 13.5144 15.935L17 13.624C15.7379 15.94 14.6865 17.867 13.5144 20L12.7957 18.697C11.8301 16.947 10.8343 15.142 10 13.624Z",
    fill: "#3AB83A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.5 6L13.5131 10.042L17 12.34L13.5 6ZM13.5164 10.756L16.8786 12.969L13.5181 15.202L13.5164 10.756ZM13.5131 15.935L17 13.624C15.9185 15.94 13.5131 20 13.5131 20V15.935Z",
    fill: "#0B8311"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEtcIcon);
export default __webpack_public_path__ + "static/media/etc-icon.4e40142b.svg";
export { ForwardRef as ReactComponent };